// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__-hyEy","closeIcon":"CloseButton_closeIcon__Zlg5V"};